"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLinkedBlueprintIdMap = void 0;
const makeLinkedBlueprintIdMap = (blueprint) => {
    const nodeIdMap = new Map();
    // First pass we grab keep the blueprintId associated to a single node id.
    blueprint.sectionBlueprints.forEach((section) => {
        section.subsections.forEach((subsection) => {
            subsection.fieldGroups.forEach((fieldGroup) => {
                fieldGroup.fields.forEach((field) => {
                    const nodeId = field.answerNodeId;
                    if (nodeId) {
                        const blueprintId = field.id;
                        const blueprintIds = nodeIdMap.get(nodeId) || [];
                        blueprintIds.push(blueprintId);
                        nodeIdMap.set(nodeId, blueprintIds);
                    }
                });
            });
        });
    });
    const linkedFields = new Map();
    // Second pass for each node-id we found, that has more than one (not just itself) blueprint id, we generate the linkedFields
    for (const item of nodeIdMap) {
        const blueprintIdsWithSameNodeId = item[1];
        for (let i = 0; i < blueprintIdsWithSameNodeId.length; i++) {
            const linkedWith = [];
            for (let j = 0; j < blueprintIdsWithSameNodeId.length; j++) {
                if (j === i) {
                    continue;
                }
                linkedWith.push(blueprintIdsWithSameNodeId[j]);
            }
            if (linkedWith.length > 0) {
                linkedFields.set(blueprintIdsWithSameNodeId[i], linkedWith);
            }
        }
    }
    return linkedFields;
};
exports.makeLinkedBlueprintIdMap = makeLinkedBlueprintIdMap;
